import ApplicationController from './application_controller';

export default class extends ApplicationController {

  static targets = ['companyFields', 'input', 'hidden']

  connect() {
    this.changeCompany();
    document.addEventListener("autocomplete.change", this.changeCompany.bind(this));
    super.connect();
  }

  changeCompany() {
    if (!this.hasInputTarget) { return }

    if (event.detail && event.detail.value != "") {
      document.querySelector('input.autocomplete#company_id').value = event.detail.value;
    }

    var disabled;
    if (this.inputTarget.value.trim() === "") {
      this.companyFieldsTarget.style.display = 'contents';
      disabled = false;
    } else {
      this.companyFieldsTarget.style.display = 'none';
      disabled = true;
    }

    // Don't send hidden input to the server. Otherwise it creates a new record instead of assigning the selected one.
    var inputs = this.companyFieldsTarget.getElementsByTagName('input');
    for (let input of inputs) { input.disabled = disabled; };
  }

}
